export const HELPDOCS_BASE_URL = "https://wixar.helpdocs.io";
export const HELPDOCS_TEAM_KEY = "883e901b-481e-4af3-8941-17f755014cae";

export const buildHelpDocsUrl = (pathOrUrl: string): string => {
  const url = new URL(pathOrUrl, HELPDOCS_BASE_URL);
  url.searchParams.set("hd_team", HELPDOCS_TEAM_KEY);
  return url.toString();
};
